/** Signing in with the mobile number the office has for the driver, and a texted code. */
import { FriendlyError } from "@taxi/mobile-web/api";
import { phone } from "@taxi/mobile-web/format";
import { BrandArt, CodeStep, PhoneStep } from "@taxi/mobile-web/sign-in";
import { useState } from "react";
import brand from "../../../../brand/brand.json";
import { fetchMe, useSession } from "../lib/session";
import type { OtpChallenge } from "../lib/types";

type Step =
  | { kind: "phone" }
  | { kind: "code"; phone: string; challenge: OtpChallenge; sentAt: number };

export function SignInScreen() {
  const { firm, firmPhone, setMe } = useSession();
  const [step, setStep] = useState<Step>({ kind: "phone" });
  const office = (
    <a href={`tel:${firmPhone}`} className="text-link">
      {phone(firmPhone)}
    </a>
  );
  return (
    <div className="sign-in">
      {step.kind === "phone" ? (
        <PhoneStep
          app="driver"
          hero={
            <>
              <BrandArt firmName={brand.firmName} />
              <h1>Ready to drive?</h1>
              <p>Sign in with the mobile number the office has for you. We'll text you a code.</p>
            </>
          }
          footer={
            <p className="fine-print">
              New to {firm.name}? The office sets drivers up first. Call {office}.
            </p>
          }
          onSent={(number, challenge) =>
            setStep({ kind: "code", phone: number, challenge, sentAt: Date.now() })
          }
        />
      ) : (
        <CodeStep
          app="driver"
          phone={step.phone}
          challenge={step.challenge}
          sentAt={step.sentAt}
          onBack={() => setStep({ kind: "phone" })}
          onResent={(challenge) => setStep({ ...step, challenge, sentAt: Date.now() })}
          onSignedIn={async () => {
            const me = await fetchMe();
            if (!me) throw new FriendlyError("That didn't work. Please try again.");
            setMe(me);
          }}
          help={
            <p className="fine-print center">
              No text? Codes only go to numbers the office has set up as drivers. Call {office}.
            </p>
          }
        />
      )}
    </div>
  );
}
